import { DrilldownTable, defaultTrafficLights, } from "../../../../../shared/interfaces-classes/index";
import { reportUtils } from '../../../../report-utils';
var getBoolFromBoolishVar = reportUtils.getBoolFromBoolishVar, processSingleVarHtml = reportUtils.processSingleVarHtml, processTemplateVarHtmlList = reportUtils.processTemplateVarHtmlList, createDrilldownTableGroup = reportUtils.createDrilldownTableGroup, getGenericGroupMsg = reportUtils.getGenericGroupMsg;
var genericGroupMsg = getGenericGroupMsg();
export var ictpItocLo2a = {
    'http://ictp-itoc-lo2a': {
        columns: [
            {
                parent: 'LO2a - Identify',
                variablename: 'Identify',
                desc: 'Identified the components of system capacity',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        success: [
                            'Identify'
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var Identify = varDict.Identify;
                        var columns = [
                            {
                                header: 'Question',
                                rows: [
                                    'Identify the key components of system capacity'
                                ],
                            },
                            {
                                header: "Choices available <br><em style=\"font-size: 0.9rem; font-weight: normal; opacity: 0.9;\">correct answers indicated with asterisks in green</em>",
                                rows: [
                                    "\n<ol>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Leadership and implementation teams</li>\n  <li>Motivational activation teams</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Workforce development systems</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Media and networking</li>\n  <li>Self-care promotion committees</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Quality and outcome monitoring systems</li>\n</ol>\n                  "
                                ],
                            },
                            {
                                header: 'Answered correctly?',
                                type: 'checkmark',
                                rows: [
                                    Identify,
                                ],
                            }
                        ];
                        var drilldownTableOpts = {
                            varDict: varDict,
                            columns: columns,
                            title: '',
                            subtitle: '',
                        };
                        var html = new DrilldownTable(drilldownTableOpts).html;
                        return html;
                    }
                },
            },
            {
                parent: 'LO2a - Challenge 1',
                variablename: 'Challenge1',
                desc: 'Identified all components of system capacity related to designing a new coaching system',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        success: [
                            'Challenge1'
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var Challenge1 = varDict.Challenge1;
                        var columns = [
                            {
                                header: 'Question',
                                rows: [
                                    'The Grand County team is working to design a coaching system to support practitioners’ use of their new innovation.  Identify all components of system capacity related to designing a new coaching system:'
                                ],
                            },
                            {
                                header: "Choices available <br><em style=\"font-size: 0.9rem; font-weight: normal; opacity: 0.9;\">correct answers indicated with asterisks in green</em>",
                                rows: [
                                    "\n<ol>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Workforce  development</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Quality and outcome monitoring system</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Media and networking</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Leadership and implementation teams</li>\n</ol>\n                  "
                                ],
                            },
                            {
                                header: 'Answered correctly?',
                                type: 'checkmark',
                                rows: [
                                    Challenge1,
                                ],
                            }
                        ];
                        var drilldownTableOpts = {
                            varDict: varDict,
                            columns: columns,
                            title: '',
                            subtitle: '',
                        };
                        var html = new DrilldownTable(drilldownTableOpts).html;
                        return html;
                    }
                },
            },
            {
                parent: 'LO2a - Challenge 2',
                variablename: 'Challenge2',
                desc: 'Identified all components of system capacity related to gathering community feedback',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        success: [
                            'Challenge2'
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var Challenge2 = varDict.Challenge2;
                        var columns = [
                            {
                                header: 'Question',
                                rows: [
                                    'The Grand County leadership team is gathering feedback from community focus groups on their early experiences with the new innovation. Identify all components of system capacity related to gathering community feedback.'
                                ],
                            },
                            {
                                header: "Choices available <br><em style=\"font-size: 0.9rem; font-weight: normal; opacity: 0.9;\">correct answers indicated with asterisks in green</em>",
                                rows: [
                                    "\n<ol>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Workforce  development</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Quality and outcome monitoring system</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Media and networking</li>\n  <li style=\"color: #2e8540; font-weight: bold;\">* Leadership and implementation teams</li>\n</ol>\n                  "
                                ],
                            },
                            {
                                header: 'Answered correctly?',
                                type: 'checkmark',
                                rows: [
                                    Challenge2,
                                ],
                            }
                        ];
                        var drilldownTableOpts = {
                            varDict: varDict,
                            columns: columns,
                            title: '',
                            subtitle: '',
                        };
                        var html = new DrilldownTable(drilldownTableOpts).html;
                        return html;
                    }
                },
            },
        ]
    }
};
